<script lang="ts">
	import { crossfade, fade, fly } from 'svelte/transition';

	let visible = false;
	function typewriter(node: any, { speed = 1 }) {
		const valid = node.childNodes.length === 1 && node.childNodes[0].nodeType === Node.TEXT_NODE;

		if (!valid) {
			throw new Error(`This transition only works on elements with a single text node child`);
		}

		const text = node.textContent;
		const duration = text.length / (speed * 0.01);

		return {
			duration,
			tick: t => {
				const i = ~~(text.length * t);
				node.textContent = text.slice(0, i);
			},
		};
	}
	const interval = 2000;
	function hideText() {
		visible = false;
		setTimeout(showText, interval);
	}
	function showText() {
		visible = true;
		setTimeout(hideText, interval);
	}
	hideText();
</script>

<!-- referencing `spinkit` https://github.com/tobiasahlin/SpinKit -->

<div class="fl cl j-c loading-cube-cover">
	{#if visible}
		<p class="message m-0" in:typewriter={{ speed: 1 }} out:fade>Loading....</p>
	{:else}
		<p class="message m-0" />
	{/if}
	<div class="sk-cube-grid">
		<div class="sk-cube sk-cube1" />
		<div class="sk-cube sk-cube2" />
		<div class="sk-cube sk-cube3" />
		<div class="sk-cube sk-cube4" />
		<div class="sk-cube sk-cube5" />
		<div class="sk-cube sk-cube6" />
		<div class="sk-cube sk-cube7" />
		<div class="sk-cube sk-cube8" />
		<div class="sk-cube sk-cube9" />
	</div>
</div>

<style lang="scss" scoped>
	// $background:#333;
	$background: #777777;
	.loading-cube-cover {
		height: 100%;
		.message {
			font-size: 1.5rem;
			max-height: 35px;
		}
		.sk-cube-grid {
			width: 60px;
			height: 60px;
			margin: 3em;

			.sk-cube {
				width: 33%;
				height: 33%;
				background-color: $background;
				float: left;
				-webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
				animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
			}

			.sk-cube1 {
				-webkit-animation-delay: 0.2s;
				animation-delay: 0.2s;
			}
			.sk-cube2 {
				-webkit-animation-delay: 0.3s;
				animation-delay: 0.3s;
			}
			.sk-cube3 {
				-webkit-animation-delay: 0.4s;
				animation-delay: 0.4s;
			}
			.sk-cube4 {
				-webkit-animation-delay: 0.1s;
				animation-delay: 0.1s;
			}
			.sk-cube5 {
				-webkit-animation-delay: 0.2s;
				animation-delay: 0.2s;
			}
			.sk-cube6 {
				-webkit-animation-delay: 0.3s;
				animation-delay: 0.3s;
			}
			.sk-cube7 {
				-webkit-animation-delay: 0s;
				animation-delay: 0s;
			}
			.sk-cube8 {
				-webkit-animation-delay: 0.1s;
				animation-delay: 0.1s;
			}
			.sk-cube9 {
				-webkit-animation-delay: 0.2s;
				animation-delay: 0.2s;
			}
		}
	}

	@-webkit-keyframes sk-cubeGridScaleDelay {
		0%,
		70%,
		100% {
			-webkit-transform: scale3D(1, 1, 1);
			transform: scale3D(1, 1, 1);
		}
		35% {
			-webkit-transform: scale3D(0, 0, 1);
			transform: scale3D(0, 0, 1);
		}
	}

	@keyframes sk-cubeGridScaleDelay {
		0%,
		70%,
		100% {
			-webkit-transform: scale3D(1, 1, 1);
			transform: scale3D(1, 1, 1);
		}
		35% {
			-webkit-transform: scale3D(0, 0, 1);
			transform: scale3D(0, 0, 1);
		}
	}
</style>
